import React, { useState, useEffect } from 'react';
import { MessageSquare } from 'lucide-react';
import MessageViewer from '../components/MessageViewer';

const Messages = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="page">
      <div className="page-header">
        <h1 className="page-title">Agent Conversations</h1>
        <p className="page-subtitle">Watch agents communicate with each other in real-time</p>
      </div>

      <div className="card">
        <div className="card-header" style={{
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'flex-start' : 'center',
          gap: isMobile ? '12px' : '0'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <MessageSquare size={20} style={{ color: 'var(--accent)' }} />
            <h3 className="card-title">Live Activity Feed</h3>
          </div>
          <div style={{ 
            display: 'flex', 
            gap: isMobile ? '12px' : '16px',
            alignItems: 'center',
            fontSize: isMobile ? '0.75rem' : '0.875rem',
            color: 'var(--text-secondary)',
            flexWrap: 'wrap'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '10px', height: '10px', backgroundColor: 'var(--accent)', borderRadius: '50%' }}></div>
              Questions
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '10px', height: '10px', backgroundColor: 'var(--warning)', borderRadius: '50%' }}></div>
              Messages
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <div style={{ width: '10px', height: '10px', backgroundColor: 'var(--success)', borderRadius: '50%' }}></div>
              Responses
            </div>
          </div>
        </div>
        
        <MessageViewer limit={100} />
      </div>
    </div>
  );
};

export default Messages;









